
export const USER_VERIFIED_MESSAGE: string = 'UserVerified';
export const USER_VERIFIED_ERROR_KEY_MESSAGE: string = 'alreadyVerified';